import { formatNumber } from "../../../../utils/format-sub";

/**
 * Requirements §4.1: three cards carrying live headline figures, not pure
 * navigation — for many owners this screen alone answers "how are we
 * doing". Attention counts appear here so a failing payment on the side of
 * the business you rarely open still catches your eye.
 */
const CARD_ORDER = ["push", "press", "all"];

const IncomeLanding = ({ landing, t }) => {
  const { contexts = {}, currency = "usd" } = landing || {};
  const money = (value) => formatNumber(value || 0, currency);

  return (
    <>
      <header className="income-landing__header">
        <h1>{t("income.landing.title")}</h1>
        <p>{t("income.landing.subtitle")}</p>
      </header>
      <section className="income-landing">
        {CARD_ORDER.filter((key) => contexts[key]?.available).map((key) => {
          const card = contexts[key];
          return (
            <a
              key={key}
              className="income-landing__card"
              data-context={key}
              href={`/coaching-portal/income?context=${key}`}
            >
              <span className="income-landing__badge">
                {t(`income.landing.${key}.title`)}
              </span>
              <h3>{t(`income.landing.${key}.blurb`)}</h3>
              <p className="income-landing__description">
                {t(`income.landing.${key}.description`)}
              </p>
              <dl>
                <div>
                  <dd>{money(card.mrr)}</dd>
                  <dt>{t("income.landing.mrr")}</dt>
                </div>
                <div>
                  <dd>{card.people}</dd>
                  <dt>{t(`income.landing.${key}.peopleLabel`)}</dt>
                </div>
                <div>
                  <dd>{money(card.revenue30d)}</dd>
                  <dt>{t("income.landing.revenue30d")}</dt>
                </div>
              </dl>
              <footer>
                {card.attentionCount > 0 ? (
                  <span className="income-landing__attention">
                    {t("income.landing.attention", {
                      count: card.attentionCount,
                    })}
                  </span>
                ) : (
                  <span />
                )}
                <span className="income-landing__open">
                  {t("income.landing.open")}
                </span>
              </footer>
            </a>
          );
        })}
      </section>
    </>
  );
};

export default IncomeLanding;
